const BASE_UNIPERSONAL = "https://iddigital.com.uy/es/solicitud-de-certificado/unipersonal";
const BASE_EMPRESA =
  "https://iddigital.com.uy/es/solicitud-de-certificado/empresa/facturacion_electronica/comun";

export type CertificateRequestCompanyType =
  | "unipersonal"
  | "sas"
  | "srl"
  | "sa"
  | "monotributo";

/**
 * Returns the ID Digital URL for the certificate request form by company type and duration.
 */
export function getIdDigitalCertificateUrl(
  companyType: CertificateRequestCompanyType,
  durationYears: 1 | 2
): string {
  if (companyType === "monotributo") {
    return `${BASE_UNIPERSONAL}/${durationYears === 1 ? "392" : "393"}`;
  }
  if (companyType === "unipersonal") {
    return `${BASE_UNIPERSONAL}/${durationYears === 1 ? "386" : "387"}`;
  }
  const segment =
    durationYears === 1
      ? "1a/persona_juridica_express_1_a/formulario"
      : "2a/persona_juridica_express_2_a/formulario";
  return `${BASE_EMPRESA}/${segment}`;
}
